// Course/curriculum catalog from the real "Cedar Vale Sixth Grade Year Plan"
// document — supersedes the earlier placeholder catalog. `id` values are
// referenced directly by yearPlanSeed.js's item generator.
export const COURSES = [
  // ── Daily six ──
  { id: 'math', name: 'Dimensions Math 5A/5B/6A', subjectArea: 'Mathematics', colorToken: '--c-math' },
  { id: 'literature', name: 'Mosdos Pearl Literature', subjectArea: 'Language Arts', colorToken: '--c-la' },
  { id: 'history', name: 'From Adam to Us', subjectArea: 'History', colorToken: '--c-history' },
  { id: 'geography', name: 'Daily Geography Practice', subjectArea: 'History', colorToken: '--c-history' },
  { id: 'typing', name: 'Touch-Type Read & Spell', subjectArea: 'STEM', colorToken: '--c-launch' },
  { id: 'spelling', name: 'Spelling You See G', subjectArea: 'Language Arts', colorToken: '--c-la' },
  { id: 'devotion', name: 'Indescribable — 100 devotions on God & science', subjectArea: 'Character', colorToken: '--c-launch' },

  // ── Weekly board ──
  { id: 'composition', name: 'Composition (Wordsmith Apprentice, then Jump In)', subjectArea: 'Language Arts', colorToken: '--c-la' },
  { id: 'cursive', name: 'Cursive (CursiveLogic, then Speeches & Writings copywork)', subjectArea: 'Language Arts', colorToken: '--c-la' },
  { id: 'digital-savvy', name: 'CompuScholar Digital Savvy', subjectArea: 'STEM', colorToken: '--c-afternoon' },
  { id: 'science', name: 'Real Science-4-Kids Book 6', subjectArea: 'Science', colorToken: '--c-afternoon' },
  { id: 'mechanics', name: 'Language mechanics (Daily Language Review Gr 3, oral)', subjectArea: 'Language Arts', colorToken: '--c-la' },
  { id: 'critical-creative', name: 'Critical & Creative Thinking 6', subjectArea: 'Logic / Critical Thinking', colorToken: '--c-logic' },
  { id: 'bonyfide', name: 'Dr. Bonyfide (books 3 & 4)', subjectArea: 'Science', colorToken: '--c-afternoon' },
  { id: 'skill-sharpeners-geography', name: 'Skill Sharpeners Geography 5', subjectArea: 'History', colorToken: '--c-history' },
  { id: 'turing-tumble', name: 'Turing Tumble', subjectArea: 'STEM', colorToken: '--c-afternoon' },

  // ── Fall co-op electives ──
  { id: 'blueprint-balances', name: 'Blueprint Balances (personal finance)', subjectArea: 'Life Skills', colorToken: '--c-afternoon' },
  { id: 'spy-academy', name: 'Spy Academy (observation & deduction)', subjectArea: 'Logic / Critical Thinking', colorToken: '--c-logic' },
  { id: 'coop-spring-elective', name: 'Spring co-op electives (not yet chosen)', subjectArea: 'Enrichment', colorToken: '--c-afternoon' },

  // ── Launch rotation ──
  { id: 'fallacy-detective', name: 'The Fallacy Detective', subjectArea: 'Logic / Critical Thinking', colorToken: '--c-logic' },
  { id: 'mindfulness', name: 'Mindfulness for Kids', subjectArea: 'Character', colorToken: '--c-launch' },

  // ── Spring unit (weeks 28-37) ──
  { id: 'spring-unit', name: 'Spring unit — WWII through graphic novels', subjectArea: 'History', colorToken: '--c-history' },

  // ── Fixed anchors ──
  { id: 'tutor', name: 'Mr. McKenzie tutoring', subjectArea: 'Fixed commitment', colorToken: '--c-tutor' },
  { id: 'swim', name: 'Swim team', subjectArea: 'Fixed commitment / PE', colorToken: '--c-swim' },
  { id: 'coop', name: 'Co-op — fall/spring electives', subjectArea: 'Fixed commitment', colorToken: '--c-tutor' },

  // Defensively upserted by scripts/syncCalendar-equivalent flows, if ever added
  { id: 'calendar', name: 'Google Calendar events', subjectArea: 'Calendar', colorToken: '--c-calendar' },
];
